import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '@environments/environment';

import { GenericService } from '@app/core/services/generic.service';

import { Loading, Censo, ChaveValor } from '@app/shared/models';

@Injectable({
  providedIn: 'root'
})
export class CensoService extends GenericService<any> {

  constructor(http: HttpClient) {
    super('censo', http);
  }

  get(loading?: Loading): Observable<ChaveValor[]> {
    this.startLoading(loading);
    return this.getHttpClient().get<ChaveValor[]>(`${this.api}/tipoDependencia`)
      .pipe(this.configMapAndLoading(loading));
  }

  buscarCenso(id: number, loading?: Loading): Observable<Censo> {
    this.startLoading(loading);
    return this.getHttpClient().get<Censo>(`${environment.api_url}/public/censo/${id}`, { headers: this.getHeadersPublico() })
      .pipe(this.configMapAndLoading(loading));
  }

  buscarTexto(id: number, campo: string, loading?: Loading): Observable<any> {
    this.startLoading(loading);
    return this.getHttpClient().get(`${environment.api_url}/public/censo/${id}/textos/${campo}`, { headers: this.getHeadersTexto(), responseType: 'text' })
      .pipe(this.stopLoading(loading));
  }

  salvarSessionStorage(key: string, dados: any): void {
    sessionStorage.setItem(key, JSON.stringify(dados));
  }

  retornarSessionStorage(key: string): any {
    const session = JSON.parse(sessionStorage.getItem(key));
    return session ? session : null;
  }

}
